import React from "react";
import { connect } from "react-redux";
import { setDashboardParams } from "../../../../store/actions";

class DashboardOfficeSelector extends React.Component {
  handleSelection = (ev) => {
    ev.preventDefault();
    this.props.setSelectedDoorCanvassPass(+ev.target.value);
  };

  render() {
    return (
      <div>
        <div className="box-select-wrapper primary-text">
          <select
            className="box-selector"
            onChange={this.handleSelection}
            value={this.props.selectedDoorCanvassPass}
          >
            <option key="0" value={0} disabled>
              - -
            </option>
            {(this.props.doorCanvassPasses || []).map((dcp) => (
              <option key={dcp.id} value={dcp.id}>
                {dcp.name}
              </option>
            ))}
          </select>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  doorCanvasses: state.doorCanvasses.data,
  doorCanvassPasses: state.doorCanvassPasses.data,
  selectedDoorCanvassPass: state.dashboardParams.selectedDoorCanvassPass,
  selectedOffice: state.dashboardParams.selectedOffice,
});

const mapDispatchToProps = (dispatch) => ({
  setSelectedDoorCanvassPass: (id) =>
    dispatch(setDashboardParams({ selectedDoorCanvassPass: id })),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardOfficeSelector);
